import * as R from 'ramda'
import { useSelector } from 'react-redux'
import { RootState } from '$setup/redux'
import { PendingEdit } from './types'

export const roomPendingEditByIidView = R.memoizeWith(
  (roomId: string, iid: number) => `${roomId}-${iid}`,
  (roomId, iid) => (state: RootState) =>
    (state.main.pendingEdits as PendingEdit[]).find(
      pending => pending.roomId === roomId && pending.iid === iid,
    ),
)

export function useRoomPendingEditByIid(roomId: string, iid: number) {
  return useSelector(roomPendingEditByIidView(roomId, iid))
}
